const Menu = [
  {
    title: "menu.home",
    group: "apps",
    name: "Hero",
    path: "/hero",
    refresh: true,
    isAdmin: false,
    isView: true,
  },
  {
    title: "menu.my-reserve",
    group: "apps",
    name: "MyMeeting",
    path: "/myMeeting",
    refresh: true,
    isAdmin: false,
    isView: true,
  },
  {
    title: "menu.join-meeting",
    group: "apps",
    name: "JoinMeeting",
    path: "/joinMeeting",
    refresh: true,
    isAdmin: false,
    isView: true,
  },
];
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js